
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const MonthWiseChart = ({ data }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-gray-400 text-sm">
        No data available
      </div>
    );
  }

  const labels = data.map((d) => d.month);
  const values = data.map((d) => Number(d.total));

  const colors = [
    "#3B82F6", // Blue
    "#06B6D4", // Cyan
    "#14B8A6", // Teal
    "#22C55E", // Green
    "#84CC16", // Lime
    "#F59E0B", // Amber
    "#F97316", // Orange
    "#EC4899", // Pink
    "#8B5CF6", // Purple
    "#6366F1", // Indigo
    "#0EA5E9", // Sky blue
    "#10B981", // Emerald
  ];

  return (
    <Bar
      data={{
        labels,
        datasets: [
          {
            label: "Bookings",
            data: values,
            backgroundColor: labels.map(
              (_, index) => colors[index % colors.length]
            ),
            hoverBackgroundColor: labels.map(
              (_, index) => colors[index % colors.length]
            ),
            barThickness: 24,
            borderRadius: 6,
            borderSkipped: false,
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 700,
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#172554",
            titleColor: "#FFFFFF",
            bodyColor: "#FFFFFF",
            padding: 10,
            displayColors: true,
            callbacks: {
              label: (context) => `Bookings: ${context.parsed.y}`,
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
              precision: 0,
              color: "#64748B",
            },
            grid: {
              color: "rgba(148, 163, 184, 0.18)",
            },
            border: {
              display: false,
            },
          },
          x: {
            ticks: {
              color: "#475569",
            },
            grid: {
              display: false,
            },
            border: {
              display: false,
            },
          },
        },
      }}
    />
  );
};

export default MonthWiseChart;
